// extracted by css-extract-rspack-plugin
export default {"root":"root-lrgOo_","box":"box-ABCQdM"};